export const VERSION = '1.0.4'
export const MINI_AUDIT_VERSION_CODE: number = 5
export const DEFAULT_FONT_SIZE = '15px'
export const STORAGE_KEY_LANG = 'lang'
export const STORAGE_KEY_CURRENT_USER_HANDLE = 'current-user-handle'
export const STORAGE_KEY_SETTINGS = 'settings'
export const STORAGE_KEY_ACCOUNT = 'account'
export const STORAGE_KEY_PROFILE = 'profile'
export const STORAGE_KEY_INVITATION = 'last-invitation'
export const STORAGE_KEY_MENU_COLLAPSE = 'menu-collapse'
export const STORAGE_KEY_BOTTOM_NAV_BUTTONS = 'bottom-nav-buttons'
export const STORAGE_KEY_THEME = 'theme'
export const STORAGE_KEY_CLIENT_TYPE = 'clientType'
export const STORAGE_KEY_MUSIC = 'music'
export const CACHE_KEY_PREVIEW_THEME = 'preview-theme'
export const CACHE_KEY_SELECT_THEME = 'selected-theme'
export const CACHE_KEY_SELECT_THEME_SERVICE_ID = 'theme-service-id'
export const CACHE_KEY_SOURCE = 'cache-source'
export const CACHE_KEY_ADD_TO_MINIPROGRAM = 'cache-add-to-miniprogram' // 缓存是否显示过添加到小程序的提醒
export const CACHE_KEY_SHOW_SUBSCRIBE_OFFICIAL_SITE = 'show-subscribe-official-site'
export const CACHE_KEY_SHOW_COUPON = 'show-coupon'
export const CACHE_KEY_SHOW_PHONE_BIND = 'show-phone-bind'
export const CACHE_KEY_SHOW_THANKS = 'show-thanks'
export const CACHE_KEY_SHOW_ZHONGYUAN = 'show-zhongyuan'
export const CACHE_KEY_SHOW_MEMORIZE_THEME_DIALOG = 'show-memorize-theme-dialog'
export const CACHE_KEY_ANNIVERSARY = 'cache-anniversary'
export const CACHE_KEY_SCHEDULE = 'cache-schedule'
export const COUPON_DOCKS = 'coupon-docks'
export const STORAGE_KEY_MEMORIZE_THANK_CONTENT = 'memorize-thank-content'

export const OFFICIAL_SITE = 'https://www.lifepage.cc'
export const USER_AGREEMENT = 'https://doc.lifepage.cc/agreement/user.html'
export const PRIVACY_AGREEMENT = 'https://doc.lifepage.cc/agreement/privacy.html'
export const MEMBER_AGREEMENT = USER_AGREEMENT
export const HELP_DOC = 'https://doc.lifepage.cc/help/help.html'

export const SALT_STR = 'lifepage4cc'

export const OPEN_URL_INVITATION = '/invitation/'
export const CACHE_KEY_SHOW_RENEW_MENTION = 'showRenewMention'

// capabilities
export const STORAGE_CAP = '50M'
export const MEMBER_STORAGE_CAP = '100G'
export const FREE_LIFE_COUNT = '2'
export const MEMBER_LIFE_COUNT = '200'
export const AI_PRO_COUNT = 100
export const AI_IMG_2_VIDEO = 30

// resource
export const WECHAT_QR_URL = 'https://lp-test-file.lifepage.cc/img/mp_qrcode.jpeg'

// restrict
export const MAX_IMG_SIZE = 20 * 1024 * 1024 // 50M
export const MAX_AUDIO_SIZE = 100 * 1024 * 1024 // 100M
export const MAX_VIDEO_SIZE = 1 * 1024 * 1024 * 1024 // 1G

export const UPLOAD_GAP = 5 * 1024 * 1024
